import { ActionMessageBuilder } from '@gogame/query';

export const messagesConcepts = new ActionMessageBuilder('Concepts');
